<template>
  <div :class="$style.profile">
    <div class="row">
      <div class="col-md-12">
        <div :class="$style.socialInfo" class="card card-body mb-4">
          <div>
            <cui-avatar :src="profile.photo" size="110" bordered="true" :borderColor="white"/>
          </div>
                  <div class="col-lg-6 col-6">
                    <div class="mb-3">
                      <div class="font-size-26 text-black">
                        <strong>Estela Camargo</strong>
                      </div>
                      <div class="font-size-14 mb-2">Data Nascimento: 02/03/1955</div>
                      <div class="font-size-14 mb-2">Tel:(11) 95083-1111</div>
                      <div class="font-size-14 mb-2">Cuidadora:(11) 9728-2020</div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-6">
                    <div class="mb-3">
                      <div class="font-size-20 text-black">
                        <strong>65 anos</strong>
                      </div>
                      <div class="font-size-16 mb-2">Altura: 1,62</div>
                    </div>
                  </div>
<!--          <div :class="$style.socialCounts">-->
<!--            <div class="text-center mr-3">-->
<!--              <h2>{{followersCount}}</h2>-->
<!--              <p class="mb-0">Followers</p>-->
<!--            </div>-->
<!--            <div class="text-center mr-3">-->
<!--              <h2>{{postsCount}}</h2>-->
<!--              <p class="mb-0">Followers</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>

      <!-- Historico Begin       -->

          <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-xl-8 col-lg-12">
          <div class="mb-5">
            <a-tabs defaultActiveKey="1">
              <a-tab-pane tab="Completo" key="1">
                <a-table
                  :columns="bestsellersColumns"
                  :dataSource="bestsellersData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="product" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <span slot="price" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
              <a-tab-pane tab="Procedimentos & Consultas" key="2">
                <a-table
                  :columns="mostViewedColumns"
                  :dataSource="mostViewedData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="product" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <span slot="price" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
              <a-tab-pane tab="Farmácia" key="3">
                <a-table
                  :columns="customersColumns"
                  :dataSource="newCustomersData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <a slot="name" slot-scope="text" href="javascript: void(0);">{{text}}</a>
                  <span slot="total" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
              <a-tab-pane tab="Exames" key="4">
                <a-table
                  :columns="customersColumns"
                  :dataSource="topCustomersData"
                  class="utils__scrollTable"
                  :scroll="{ x: '100%' }"
                >
                  <span slot="total" slot-scope="text">${{text}}</span>
                </a-table>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>
          </div>

      <!-- Historico Ends        -->

        <div class="card">
          <div class="card-body">
            <a-tabs defaultActiveKey="1">
              <a-tab-pane key="1">
                <span slot="tab">
                  <span>
                    <i class="icmn-menu"/> Atendimento
                  </span>
                </span>
                <div class="py-3">
                  <a-textarea placeholder="Basic usage" :rows="4"/>
                  <div class="mt-3">
                    <a-button class="mr-2" type="primary" style="width: 200px">
                      <i class="fa fa-send mr-2"/>
                      Create Post
                    </a-button>
                    <a-upload
                      name="file"
                      :multiple="true"
                      action="//jsonplaceholder.typicode.com/posts/"
                      :headers="headers"
                      @change="handleChange"
                    >
                      <a-button>
                        <a-icon type="upload"/>Click to Upload
                      </a-button>
                    </a-upload>
                  </div>
                </div>
                <div v-for="(item, index) in posts" :key="index">
                  <div :class="$style.wallItem" class="clearfix">
                    <div :class="$style.wallAvatar">
                      <cui-avatar size="50" :src="item.avatar" :bordered="false"/>
                    </div>
                    <div :class="$style.wallContent">
                      <div class="mb-3">
                        <div class="pull-right">
                          <a-dropdown>
                            <a class="ant-dropdown-link" href="javascript: void(0);">Actions
                              <a-icon type="down"/>
                            </a>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a href="javascript:void(0)">
                                  <a-icon type="edit"/>Edit Post
                                </a>
                              </a-menu-item>
                              <a-menu-item>
                                <a href="javascript:void(0)">
                                  <a-icon type="delete"/>Delete Post
                                </a>
                              </a-menu-item>
                              <a-menu-item>
                                <a href="javascript:void(0)">
                                  <a-icon type="frown-o"/>Mark as a Spam
                                </a>
                              </a-menu-item>
                            </a-menu>
                          </a-dropdown>
                        </div>
                        <strong>{{item.name}}</strong> posted:
                        <br>
                        <small class="text-muted">{{item.date}}</small>
                      </div>
                      <div class="mb-3" v-html="item.content"></div>
                      <a href="javascript: void(0);" class="mr-3">
                        <i class="icmn-heart mr-2"/>
                        <span v-if="item.likesCount > 0">{{item.likesCount}} Likes</span>
                        <span v-if="item.likesCount === 0">{{item.likesCount}} Like</span>
                      </a>
                      <a href="javascript: void(0);" class="mr-3">
                        <i class="icmn-bubble mr-2"/>
                        <span v-if="item.commentsCount > 0">{{item.commentsCount}} Comments</span>
                        <span v-if="item.commentsCount === 0">{{item.commentsCount}} Comment</span>
                      </a>
                    </div>
                  </div>
                  <div :class="[$style.wallContent, $style.wallInnerContent]">
                    <div :class="$style.wallComments">
                      <div
                        :class="$style.wallItem"
                        class="clearfix"
                        v-for="(postComment, index) in item.comments"
                        :key="index"
                      >
                        <div :class="$style.wallAvatar">
                          <cui-avatar size="50" :src="postComment.avatar" :bordered="false"/>
                        </div>
                        <div :class="$style.wallContent">
                          <div class="clearfix">
                            <div class="pull-right">
                              <a-dropdown>
                                <a class="ant-dropdown-link" href="javascript: void(0);">Actions
                                  <a-icon type="down"/>
                                </a>
                                <a-menu slot="overlay">
                                  <a-menu-item>
                                    <a href="javascript:void(0)">
                                      <a-icon type="edit"/>Edit Post
                                    </a>
                                  </a-menu-item>
                                  <a-menu-item>
                                    <a href="javascript:void(0)">
                                      <a-icon type="delete"/>Delete Post
                                    </a>
                                  </a-menu-item>
                                  <a-menu-item>
                                    <a href="javascript:void(0)">
                                      <a-icon type="frown-o"/>Mark as a Spam
                                    </a>
                                  </a-menu-item>
                                </a-menu>
                              </a-dropdown>
                            </div>
                            <strong>{{postComment.name}}</strong> posted:
                            <br>
                            <small class="text-muted">{{postComment.date}}</small>
                          </div>
                          <div class="mb-3" v-html="postComment.content"></div>
                          <a href="javascript: void(0);" class="mr-3">
                            <i class="icmn-heart mr-2"/>
                            <span v-if="postComment.likesCount > 0">{{postComment.likesCount}} Likes</span>
                            <span
                              v-if="postComment.likesCount === 0"
                            >{{postComment.likesCount}} Like</span>
                          </a>
                          <a href="javascript: void(0);" class="mr-3">
                            <i class="icmn-bubble mr-2"/>
                            <span
                              v-if="postComment.commentsCount > 0"
                            >{{postComment.commentsCount}} Comments</span>
                            <span
                              v-if="postComment.commentsCount === 0"
                            >{{postComment.commentsCount}} Comment</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2">
                <span slot="tab">
                  <span>
                    <i class="icmn-bubbles"/> Mensagens
                  </span>
                </span>
                <cui-chat/>
              </a-tab-pane>
              <a-tab-pane key="3">
                <span slot="tab">
                  <i class="icmn-cog"/> Onboarding
                </span>
                <a-form :form="form">
                  <h5 class="text-black mt-2 mb-3">
                    <strong>Personal Information</strong>
                  </h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <a-form-item label="Username">
                        <a-input placeholder="Username" v-decorator="['username']"/>
                      </a-form-item>
                    </div>
                    <div class="col-lg-6">
                      <a-form-item label="Email">
                        <a-input placeholder="Email" v-decorator="['discount']"/>
                      </a-form-item>
                    </div>
                  </div>
                  <h5 class="text-black mt-2 mb-3">
                    <strong>New Password</strong>
                  </h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <a-form-item label="Password">
                        <a-input placeholder="Password" v-decorator="['password']"/>
                      </a-form-item>
                    </div>
                    <div class="col-lg-6">
                      <a-form-item label="Confirm Password">
                        <a-input placeholder="Confirm Password" v-decorator="['confirmPassword']"/>
                      </a-form-item>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h5 class="text-black mt-2 mb-3">
                        <strong>Profile Avatar</strong>
                      </h5>
                      <a-form-item>
                        <a-upload
                          name="file"
                          :multiple="true"
                          action="//jsonplaceholder.typicode.com/posts/"
                          :headers="headers"
                          @change="handleChange"
                        >
                          <a-button>
                            <a-icon type="upload"/>Click to Upload
                          </a-button>
                        </a-upload>
                      </a-form-item>
                    </div>
                    <div class="col-lg-6">
                      <h5 class="text-black mt-2 mb-3">
                        <strong>Profile Background</strong>
                      </h5>
                      <a-form-item>
                        <a-upload
                          name="file"
                          :multiple="true"
                          action="//jsonplaceholder.typicode.com/posts/"
                          :headers="headers"
                          @change="handleChange"
                        >
                          <a-button>
                            <a-icon type="upload"/>Click to Upload
                          </a-button>
                        </a-upload>
                      </a-form-item>
                    </div>
                  </div>
                  <div class="form-actions mt-0">
                    <a-button
                      style="width: 150px;"
                      type="primary"
                      htmlType="submit"
                      class="mr-3"
                    >Submit</a-button>
                    <a-button htmlType="submit">Cancel</a-button>
                  </div>
                </a-form>
              </a-tab-pane>
              <a-tab-pane key="4">
                <span slot="tab">
                  <i class="icmn-cog"/> Plano de Cuidado
                </span>
                <a-form :form="form">
                  <h5 class="text-black mt-2 mb-3">
                    <strong>Personal Information</strong>
                  </h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <a-form-item label="Username">
                        <a-input placeholder="Username" v-decorator="['username']"/>
                      </a-form-item>
                    </div>
                    <div class="col-lg-6">
                      <a-form-item label="Email">
                        <a-input placeholder="Email" v-decorator="['discount']"/>
                      </a-form-item>
                    </div>
                  </div>
                  <h5 class="text-black mt-2 mb-3">
                    <strong>New Password</strong>
                  </h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <a-form-item label="Password">
                        <a-input placeholder="Password" v-decorator="['password']"/>
                      </a-form-item>
                    </div>
                    <div class="col-lg-6">
                      <a-form-item label="Confirm Password">
                        <a-input placeholder="Confirm Password" v-decorator="['confirmPassword']"/>
                      </a-form-item>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h5 class="text-black mt-2 mb-3">
                        <strong>Profile Avatar</strong>
                      </h5>
                      <a-form-item>
                        <a-upload
                          name="file"
                          :multiple="true"
                          action="//jsonplaceholder.typicode.com/posts/"
                          :headers="headers"
                          @change="handleChange"
                        >
                          <a-button>
                            <a-icon type="upload"/>Click to Upload
                          </a-button>
                        </a-upload>
                      </a-form-item>
                    </div>
                    <div class="col-lg-6">
                      <h5 class="text-black mt-2 mb-3">
                        <strong>Profile Background</strong>
                      </h5>
                      <a-form-item>
                        <a-upload
                          name="file"
                          :multiple="true"
                          action="//jsonplaceholder.typicode.com/posts/"
                          :headers="headers"
                          @change="handleChange"
                        >
                          <a-button>
                            <a-icon type="upload"/>Click to Upload
                          </a-button>
                        </a-upload>
                      </a-form-item>
                    </div>
                  </div>
                  <div class="form-actions mt-0">
                    <a-button
                      style="width: 150px;"
                      type="primary"
                      htmlType="submit"
                      class="mr-3"
                    >Submit</a-button>
                    <a-button htmlType="submit">Cancel</a-button>
                  </div>
                </a-form>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  name,
  nickname,
  photo,
  background,
  post,
  tel1,
  tel2,
  postsCount,
  followersCount,
  lastActivity,
  status,
  skills,
  coursesEnd,
  adress,
  profSkills,
  lastCompanies,
  personal,
  posts,
  profile,
  bestsellersData,
  mostViewedData,
} from './data.json'
import CuiAvatar from '@/components/CleanUIComponents/Avatar'
import CuiChat from '@/components/CleanUIComponents/Chat'

const bestsellersColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Nome',
    dataIndex: 'product',
    key: 'product',
    sorter: (a, b) => a.product - b.product,
    scopedSlots: { customRender: 'product' },
  },
  {
    title: 'Idade',
    dataIndex: 'price',
    key: 'price',
    sorter: (a, b) => a.price - b.price,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: 'Gênero',
    dataIndex: 'orderquantity',
    key: 'orderquantity',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
  {
    title: 'Localização',
    dataIndex: 'orderquantity',
    key: 'orderquantity1',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
  {
    title: 'Ind. Risco',
    dataIndex: 'orderquantity',
    key: 'orderquantity2',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
  {
    title: 'Ind. Saúde',
    dataIndex: 'orderquantity',
    key: 'orderquantity3',
    sorter: (a, b) => a.orderquantity - b.orderquantity,
  },
]

const mostViewedColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    sorter: (a, b) => a.product - b.product,
    scopedSlots: { customRender: 'product' },
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    sorter: (a, b) => a.price - b.price,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: 'Views',
    dataIndex: 'views',
    key: 'views',
    sorter: (a, b) => a.views - b.views,
  },
]

export default {
  components: {
    CuiAvatar,
    CuiChat,
  },
  data: function () {
    return {
      name,
      nickname,
      photo,
      background,
      post,
      postsCount,
      tel1,
      tel2,
      followersCount,
      lastActivity,
      status,
      skills,
      coursesEnd,
      adress,
      profSkills,
      lastCompanies,
      personal,
      posts,
      bestsellersData,
      bestsellersColumns,
      mostViewedData,
      mostViewedColumns,
      profile,
      form: this.$form.createForm(this),
    }
  },
  methods: {
    handleChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
